import { C } from "../theme/colors";
import Divider from "../components/Divider";
import Section from "../components/Section";
import PageHero from "../components/PageHero";

export default function MissionPage() {
  const pillars = [
    {color:C.navy,icon:"🔬",title:"Advance Research",desc:"Cutting-edge collaborative research with national and international partners."},
    {color:C.teal,icon:"💡",title:"Foster Innovation",desc:"Harness innovative ideas from faculty, research scholars, and students."},
    {color:C.blue,icon:"🎓",title:"Enhance Skills",desc:"Upskill security professionals through tailored certification programs."},
    {color:C.green,icon:"🛡",title:"Self-Reliance",desc:"Develop indigenous technologies to achieve independence in national security."},
  ];
  return (
    <div className="page-fade">
      <PageHero title="Our Mission" tag="Strategic Purpose" subtitle="Collaborating with key stakeholders to advance research, foster innovation, and build India's self-reliance in national security."/>
      <Section>
        <div style={{display:"grid",gridTemplateColumns:"3fr 2fr",gap:72,alignItems:"start"}} className="grid-2">
          <div>
            <span className="section-tag">Purpose Statement</span>
            <h2 style={{fontFamily:"var(--font-heading)",fontWeight:700,fontSize:"clamp(1.4rem,2.2vw,2rem)",color:C.navyDark,marginTop:10}}>Building a Self-Reliant Nation</h2>
            <Divider/>
            <p className="body" style={{marginBottom:18,fontSize:16,lineHeight:2}}>CRENS is established at BITS Pilani Hyderabad Campus with the aim to address national security challenges by collaborating with key stakeholders in the defence and security ecosystem.</p>
            <p className="body" style={{marginBottom:18}}>The Centre shall collaborate with all stakeholders and focus on advancing research, fostering innovation, and enhancing the skill sets of professionals.</p>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {pillars.map((m,i) => (
              <div key={i} style={{padding:"18px 20px",background:C.white,borderRadius:10,border:`1px solid ${C.border}`,borderLeft:`3px solid ${m.color}`,display:"flex",gap:14,alignItems:"flex-start"}}>
                <div style={{fontSize:20,flexShrink:0,marginTop:1}}>{m.icon}</div>
                <div>
                  <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:700,color:m.color,marginBottom:4}}>{m.title}</div>
                  <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13,color:C.textMid,lineHeight:1.6}}>{m.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>
    </div>
  );
}